import React, { useState, useEffect } from 'react';
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form, Modal, Row, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import { PencilIcon } from '@primer/octicons-react'
import { BiPlus, BiTrash } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { testJSON } from '../utils/jsUtils';


const ActionAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [actionAttrs, setActionAttrs] = useState({
    id: '',
    name: '',
    description: '',
    type: '',
    status: ''
  });

  const [currentActionAttrs, setCurrentActionAttrs] = useState([]);

  const typeOptions = [
    { key: "ACT_TYPE_SEND_NOTIF",  value: "ACT_TYPE_SEND_NOTIF" },
    { key: "ACT_TYPE_CREATE_WO",   value: "ACT_TYPE_CREATE_WO" }
  ];

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];


  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  const [notifTypeList, setNotifTypeList] = useState([]);

  //const [showNotifTypeInfo, setShowNotifTypeInfo] = useState(false);
  //const [notifTypeSelected, setNotifTypeSelected] = useState();

  const [notifTypeAddList, setNotifTypeAddList] = useState([]);

  const [unassignedNotifTypeList, setUnassignedNotifTypeList] = useState();

  const [showAddNotifTypeDialog, setShowAddNotifTypeDialog] = useState(false);
  const [addNotifTypeErrMsg, setAddNotifTypeErrMsg] = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      setActionAttrsWithFormatting(props.objDetails);

      fetchAssociatedNotifTypes(props.objDetails.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const setActionAttrsWithFormatting = (details) => {
      // Properly format receiver settings JSON
      // Makes a deep copy
      let inputDetails = JSON.parse (JSON.stringify (details));

      inputDetails.config = (inputDetails.config === null) ? '' :
                            JSON.stringify(JSON.parse(JSON.stringify(details.config)), undefined, 4);

      setActionAttrs(inputDetails);
      setCurrentActionAttrs(inputDetails);
  }


  const fetchAssociatedNotifTypes = (actionId) => {

    if (!actionId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("actions/" + actionId + "/notif-types");

        resolve(res.data);

        if (res.status === 200) {
          setNotifTypeList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const fetchUnassignedNotifTypes = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types?searchTerms=");

        resolve(res.data);

        if (res.status === 200) {

          //const cleanList = res.data.filter(notifType => notifType.name !== '--');
          const cleanList = res.data.data;

          // Remove datapoint types already assigned to the user
          let tempList = [];

          for (let i=0; i<notifTypeList.length; i++) {
            tempList.push(notifTypeList[i].name);
          }

          let unassignedList = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!tempList.includes(cleanList[i].name)) {
              unassignedList.push(cleanList[i]);
            }
          }

          setUnassignedNotifTypeList(unassignedList);
        }

        setErrMsg(''); //### NEED TO FIX
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));  //### NEED TO FIX
      }
    });
  }


  const onTypeSelect = (key, event) => {
    setActionAttrs({ ...actionAttrs, type: key });
  }

  const onStatusSelect = (key, event) => {
    setActionAttrs({ ...actionAttrs, status: key });
  };

  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setActionAttrs({ ...actionAttrs, [e.target.name]: e.target.value })
  }

  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setActionAttrs (currentActionAttrs);

    setEditMode(false);
    setErrMsg('');
  }

  const handleEditSubmit = (e) => {
     e.preventDefault();

    if (!actionAttrs.name || actionAttrs.name.trim().length === 0) {
       setErrMsg(t("I18N_ERR_Need_name"));
    } else if (actionAttrs.name !== currentActionAttrs.name) {
      validateName();
    } else {
      validateOtherFields();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("actions?name=" + actionAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // Action name is taken
          setErrMsg(t("I18N_ERR_Name_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if (actionAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;
    } else if (!actionAttrs.description || actionAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (actionAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!actionAttrs.type || actionAttrs.type.length === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));
      return;
    } else if (!actionAttrs.status || actionAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;
    } else if (   (actionAttrs.config !== '')
               && (!testJSON(actionAttrs.config.trim()))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Config_need_valid_JSON"));
      return;
    }

    updateAction();
  }

  const updateAction = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(actionAttrs));

    if ((actionAttrs.config == null) || (actionAttrs.config === '')) {
      reqBody.config = null;
    } else {
      reqBody.config = JSON.parse(actionAttrs.config.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("actions/" + actionAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          // Restore UI to viewing mode
          setEditMode(false);
          setErrMsg('');

          fetchAction(actionAttrs.id);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });

  }


  const fetchAction = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("actions/" + id);

        resolve(res.data);

        if (   (res.status === 200)
            && (res.data && res.data.length > 0)) {
          setActionAttrsWithFormatting(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  // Notification related stuff

/*
  function handleNotifTypeInfo(notifType) {

    //setNotifTypeSelected(notifType);
    //setShowNotifTypeInfo(true);
  }

  const handleNotifTypeInfoClose = (e) => {
    //setNotifTypeSelected(null);
    //setShowNotifTypeInfo(false);
  }
*/


  function handleAddNotifTypes() {
    fetchUnassignedNotifTypes();
    setShowAddNotifTypeDialog(true);
  }

  function handleAddNotifTypesClose() {
    setNotifTypeAddList([]);
    setShowAddNotifTypeDialog(false);
  }

  function handleAddNotifTypesSubmit() {
    let newNotifTypeList = [];

    if (notifTypeAddList.length === 0) {
      setAddNotifTypeErrMsg(t("I18N_ERR_No_item_selected"));
      return;
    }

    for (let i=0; i<notifTypeAddList.length; i++) {
      newNotifTypeList.push(notifTypeAddList[i]);
    }

    let reqBody = {
          notifTypeIdList: newNotifTypeList
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("actions/" + actionAttrs.id + "/notif-types", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setNotifTypeAddList([]);
          setAddNotifTypeErrMsg('');
          setShowAddNotifTypeDialog(false);
          fetchAssociatedNotifTypes(actionAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddNotifTypeErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function handleRemoveNotifType(notifType) {

    let reqBody = {
          data: {
             "notifTypeIdList": []
          }
        };

    reqBody.data.notifTypeIdList.push(notifType.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("actions/" + actionAttrs.id + "/notif-types/", reqBody);

        resolve(res.data);
        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedNotifTypes(actionAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const handleNotifTypeSelect = (e) => {

    if (e.target.checked) {
      // Add notifType to the list
      notifTypeAddList.push(e.target.id);
    } else {
      const index = notifTypeAddList.indexOf(e.target.id);
      if (index > -1) {
        notifTypeAddList.splice(index, 1);
      }
    }

    setNotifTypeAddList(notifTypeAddList);
  }


  function renderNotifType(notifType, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleNotifTypeInfo(notifType)}>{notifType.name}</span></td>
*/}
        <td>{notifType.name}</td>
        <td>{notifType.description}</td>
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveNotifType(notifType)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }


  function renderAddNotifTypes(notifType, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={notifType.id} label="" onChange={handleNotifTypeSelect} /></td>
        <td>{notifType.name}</td>
        <td>{notifType.description}</td>
      </tr>
    )
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Action_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Action_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Name")}: *</Col>
                  <Col md={3}>{t("I18N_Description")}: *</Col>
                  <Col md={3}>{t("I18N_Type")}: *</Col>
                  <Col md={3}>{t("I18N_Status")}: *</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={actionAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={actionAttrs.description}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!actionAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (typeOptions.find( ({ key }) => key === actionAttrs.type )).value)}
                      onSelect={onTypeSelect}>
                      {typeOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!actionAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === actionAttrs.status )).value)}
                      onSelect={onStatusSelect}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Config")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="config"
                              value={(actionAttrs.config === null ? '' : actionAttrs.config)} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Name")}:</Col>
                <Col md={3}>{t("I18N_Description")}:</Col>
                <Col md={3}>{t("I18N_Type")}:</Col>
                <Col md={3}>{t("I18N_Status")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{actionAttrs.name}</Col>
                <Col style={{maxHeight:'80px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {actionAttrs.description}
                </Col>
                <Col md={3}>{t("I18N_" + actionAttrs.type)}</Col>
                <Col md={3}>{t("I18N_" + actionAttrs.status)}</Col>
              </Row>

{/*
                            value={(actionAttrs.config === null ? '' : actionAttrs.config)} />
                            value={actionAttrs.config === null ? 'AAA' : 'BBB'} />
                            value={actionAttrs.config === null ? 'AAA' : actionAttrs.config.length} />
*/}
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>{t("I18N_Config")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="config"
                            value={actionAttrs.config} />
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{actionAttrs.creatorUsername}</Col>
                <Col>{formatDate(actionAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{actionAttrs.updaterUsername}</Col>
                <Col>{formatDate(actionAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>


        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Associated_notif_types")}
            </span>
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <OverlayTrigger overlay={<Tooltip id="tooltip-new_notifType" style={{fontSize:'11px'}}>{t("I18N_TIP_Add_notif_type")}</Tooltip>}>
                <span onClick={handleAddNotifTypes} style={{ marginLeft: '0px', marginRight: '0px', marginTop: '3px', cursor: 'pointer', color: 'rgb(100,100,100)' }}>
                  <BiPlus size={18} />
                </span>
              </OverlayTrigger>
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{fontWeight:'400'}}>{t("I18N_Notiftype_name")}</th>
                  <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(notifTypeList && notifTypeList.length > 0) ? notifTypeList.map(renderNotifType) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateActionErrMsg}
              </span>
*/}
          </Form.Group>
        </div>

        <Modal show={showAddNotifTypeDialog} onHide={handleAddNotifTypesClose} centered >
          <Modal.Body style={{height:'600px', overflow:'auto'}}>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_Notiftypes")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', maxHeight:'500px', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Notiftype_name")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedNotifTypeList ? unassignedNotifTypeList.map(renderAddNotifTypes) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddNotifTypesClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddNotifTypesSubmit}>
                {t("I18N_TIP_Add_notif_type")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addNotifTypeErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}

export default ActionAdminDetailsView;
